import type { MapSpawn } from "./types";

const spawns: MapSpawn[] = [
  // --- map-groudon ---
  {
    mapId: "map-groudon",
    neutralId: "groudon",
    left: "50%",
    top: "43%",
    spawnTime: "02:00",
    respawnTime: 0,
    permanentDelete: false,
    infoKey: "groudon.boss",
  },
  {
    mapId: "map-groudon",
    neutralId: "bunnelby",
    left: "19.5%",
    top: "47%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.initial",
  },
  {
    mapId: "map-groudon",
    neutralId: "bunnelby",
    left: "20.5%",
    top: "38.5%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.initial",
  },
  {
    mapId: "map-groudon",
    neutralId: "bunnelby",
    left: "22.21%",
    top: "58%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.initial",
  },
  {
    mapId: "map-groudon",
    neutralId: "bunnelby",
    left: "25.5%",
    top: "29.5%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.initial",
  },
  {
    mapId: "map-groudon",
    neutralId: "bunnelby",
    left: "32.74%",
    top: "65.02%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.initial",
  },
  {
    mapId: "map-groudon",
    neutralId: "bunnelby",
    left: "34%",
    top: "22.5%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.initial",
  },
  {
    mapId: "map-groudon",
    neutralId: "bunnelby",
    left: "80.5%",
    top: "49.5%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.initial",
  },
  {
    mapId: "map-groudon",
    neutralId: "bunnelby",
    left: "80%",
    top: "37.5%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.initial",
  },
  {
    mapId: "map-groudon",
    neutralId: "bunnelby",
    left: "77%",
    top: "58%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.initial",
  },
  {
    mapId: "map-groudon",
    neutralId: "bunnelby",
    left: "75%",
    top: "29.5%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.initial",
  },
  {
    mapId: "map-groudon",
    neutralId: "bunnelby",
    left: "67.5%",
    top: "67%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.initial",
  },
  {
    mapId: "map-groudon",
    neutralId: "bunnelby",
    left: "66%",
    top: "22.5%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.initial",
  },
  {
    mapId: "map-groudon",
    neutralId: "bunnelby",
    left: "50.06%",
    top: "13.54%",
    spawnTime: "09:40",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "bunnelby.lane_940",
  },
  {
    mapId: "map-groudon",
    neutralId: "bunnelby",
    left: "56.84%",
    top: "12.37%",
    spawnTime: "09:20",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "bunnelby.lane_920",
  },
  {
    mapId: "map-groudon",
    neutralId: "bunnelby",
    left: "43.5%",
    top: "13.5%",
    spawnTime: "09:20",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "bunnelby.lane_920",
  },
  {
    mapId: "map-groudon",
    neutralId: "bunnelby",
    left: "48.89%",
    top: "75.55%",
    spawnTime: "09:40",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "bunnelby.lane_940",
  },
  {
    mapId: "map-groudon",
    neutralId: "bunnelby",
    left: "51.7%",
    top: "75.55%",
    spawnTime: "09:40",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "bunnelby.lane_940",
  },
  {
    mapId: "map-groudon",
    neutralId: "bunnelby",
    left: "50.06%",
    top: "59.76%",
    spawnTime: "09:15",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "bunnelby.lane_915",
  },
  {
    mapId: "map-groudon",
    neutralId: "accelgor",
    left: "35%",
    top: "52%",
    spawnTime: "09:45",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "accelgor",
  },
  {
    mapId: "map-groudon",
    neutralId: "accelgor",
    left: "65%",
    top: "52%",
    spawnTime: "09:45",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "accelgor",
  },
  {
    mapId: "map-groudon",
    neutralId: "escavalier",
    left: "35%",
    top: "35.5%",
    spawnTime: "09:45",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "escavalier",
  },
  {
    mapId: "map-groudon",
    neutralId: "escavalier",
    left: "65%",
    top: "35%",
    spawnTime: "09:45",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "escavalier",
  },
  {
    mapId: "map-groudon",
    neutralId: "baltoy",
    left: "28.5%",
    top: "38.5%",
    spawnTime: "09:45",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.generic",
  },
  {
    mapId: "map-groudon",
    neutralId: "baltoy",
    left: "28%",
    top: "49.5%",
    spawnTime: "09:45",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.generic",
  },
  {
    mapId: "map-groudon",
    neutralId: "baltoy",
    left: "71.5%",
    top: "38%",
    spawnTime: "09:45",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.generic",
  },
  {
    mapId: "map-groudon",
    neutralId: "baltoy",
    left: "72.5%",
    top: "50%",
    spawnTime: "09:45",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.generic",
  },
  {
    mapId: "map-groudon",
    neutralId: "baltoy",
    left: "56%",
    top: "23%",
    spawnTime: "09:40",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_940",
  },
  {
    mapId: "map-groudon",
    neutralId: "baltoy",
    left: "44%",
    top: "23.5%",
    spawnTime: "09:40",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_940",
  },
  {
    mapId: "map-groudon",
    neutralId: "baltoy",
    left: "50.06%",
    top: "10.03%",
    spawnTime: "09:10",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_910",
  },
  {
    mapId: "map-groudon",
    neutralId: "baltoy",
    left: "35%",
    top: "14%",
    spawnTime: "09:10",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_910_only",
  },
  {
    mapId: "map-groudon",
    neutralId: "baltoy",
    left: "67.26%",
    top: "12.37%",
    spawnTime: "09:10",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_910_only",
  },
  {
    mapId: "map-groudon",
    neutralId: "baltoy",
    left: "33%",
    top: "75%",
    spawnTime: "09:10",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_910_short",
  },
  {
    mapId: "map-groudon",
    neutralId: "baltoy",
    left: "67.5%",
    top: "76%",
    spawnTime: "09:10",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_910_only",
  },
  {
    mapId: "map-groudon",
    neutralId: "baltoy",
    left: "43.5%",
    top: "43.5%",
    spawnTime: "08:40",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_840",
  },
  {
    mapId: "map-groudon",
    neutralId: "baltoy",
    left: "57%",
    top: "43%",
    spawnTime: "08:40",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_840",
  },
  {
    mapId: "map-groudon",
    neutralId: "baltoy",
    left: "30%",
    top: "32%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.tower",
  },
  {
    mapId: "map-groudon",
    neutralId: "baltoy",
    left: "71.5%",
    top: "32.5%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.tower",
  },
  {
    mapId: "map-groudon",
    neutralId: "baltoy",
    left: "27.5%",
    top: "54%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.tower",
  },
  {
    mapId: "map-groudon",
    neutralId: "baltoy",
    left: "72%",
    top: "54.5%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.tower",
  },
  {
    mapId: "map-groudon",
    neutralId: "regidrago",
    left: "50%",
    top: "51.5%",
    spawnTime: "08:00",
    respawnTime: 120,
    permanentDelete: false,
    despawnTime: "02:30",
    infoKey: "regidrago",
  },
  {
    mapId: "map-groudon",
    neutralId: "regieleki",
    left: "50%",
    top: "9.5%",
    spawnTime: "07:00",
    respawnTime: 120,
    permanentDelete: false,
    despawnTime: "02:00",
    infoKey: "regieleki",
  },
  {
    mapId: "map-groudon",
    neutralId: "regieleki",
    left: "50.06%",
    top: "84.91%",
    spawnTime: "07:00",
    respawnTime: 120,
    permanentDelete: false,
    despawnTime: "02:00",
    infoKey: "regieleki",
  },
  {
    mapId: "map-groudon",
    neutralId: "regice",
    left: "50%",
    top: "4%",
    spawnTime: "07:00",
    respawnTime: 120,
    permanentDelete: false,
    despawnTime: "02:00",
    infoKey: "regi.700",
  },
  {
    mapId: "map-groudon",
    neutralId: "regice",
    left: "50%",
    top: "90%",
    spawnTime: "07:00",
    respawnTime: 120,
    permanentDelete: false,
    despawnTime: "02:00",
    infoKey: "regi.700",
  },
  {
    mapId: "map-groudon",
    neutralId: "registeel",
    left: "46.5%",
    top: "7.5%",
    spawnTime: "07:00",
    respawnTime: 120,
    permanentDelete: false,
    despawnTime: "02:00",
    infoKey: "regi.700",
  },
  {
    mapId: "map-groudon",
    neutralId: "registeel",
    left: "46%",
    top: "88.5%",
    spawnTime: "07:00",
    respawnTime: 120,
    permanentDelete: false,
    despawnTime: "02:00",
    infoKey: "regi.700",
  },
  {
    mapId: "map-groudon",
    neutralId: "regirock",
    left: "53.5%",
    top: "8.5%",
    spawnTime: "07:00",
    respawnTime: 120,
    permanentDelete: false,
    despawnTime: "02:00",
    infoKey: "regi.700",
  },
  {
    mapId: "map-groudon",
    neutralId: "regirock",
    left: "54%",
    top: "88.5%",
    spawnTime: "07:00",
    respawnTime: 120,
    permanentDelete: false,
    despawnTime: "02:00",
    infoKey: "regi.700",
  },
  {
    mapId: "map-groudon",
    neutralId: "xatu",
    left: "25.5%",
    top: "43.5%",
    spawnTime: "09:59",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "xatu",
  },
  {
    mapId: "map-groudon",
    neutralId: "xatu",
    left: "74.5%",
    top: "43%",
    spawnTime: "09:59",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "xatu",
  },
  {
    mapId: "map-groudon",
    neutralId: "natu",
    left: "51%",
    top: "42.5%",
    spawnTime: "09:00",
    respawnTime: 0,
    permanentDelete: true,
    despawnTime: "02:00",
    infoKey: "natu.900",
  },
  {
    mapId: "map-groudon",
    neutralId: "natu",
    left: "49%",
    top: "42.5%",
    spawnTime: "09:20",
    respawnTime: 60,
    permanentDelete: false,
    despawnTime: "02:00",
    infoKey: "natu.920",
  },
  {
    mapId: "map-groudon",
    neutralId: "indeedee",
    left: "42%",
    top: "77%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.lane_930",
  },
  {
    mapId: "map-groudon",
    neutralId: "indeedee",
    left: "42.5%",
    top: "63%",
    spawnTime: "09:35",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.lane_935",
  },
  {
    mapId: "map-groudon",
    neutralId: "indeedee",
    left: "57.5%",
    top: "76.5%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.lane_930",
  },
  {
    mapId: "map-groudon",
    neutralId: "indeedee",
    left: "56.5%",
    top: "63%",
    spawnTime: "09:35",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.lane_935",
  },
  {
    mapId: "map-groudon",
    neutralId: "indeedee",
    left: "29%",
    top: "17.5%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.tower",
  },
  {
    mapId: "map-groudon",
    neutralId: "indeedee",
    left: "22.5%",
    top: "23.5%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.tower",
  },
  {
    mapId: "map-groudon",
    neutralId: "indeedee",
    left: "19%",
    top: "31%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.tower",
  },
  {
    mapId: "map-groudon",
    neutralId: "indeedee",
    left: "71.5%",
    top: "18.5%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.tower",
  },
  {
    mapId: "map-groudon",
    neutralId: "indeedee",
    left: "77.5%",
    top: "23.5%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.tower",
  },
  {
    mapId: "map-groudon",
    neutralId: "indeedee",
    left: "81.5%",
    top: "31.5%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.tower",
  },
  {
    mapId: "map-groudon",
    neutralId: "indeedee",
    left: "16.5%",
    top: "59.5%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.tower",
  },
  {
    mapId: "map-groudon",
    neutralId: "indeedee",
    left: "19.5%",
    top: "65%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.tower",
  },
  {
    mapId: "map-groudon",
    neutralId: "indeedee",
    left: "81%",
    top: "64.5%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.tower",
  },
  {
    mapId: "map-groudon",
    neutralId: "indeedee",
    left: "84%",
    top: "59%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.tower",
  },
  {
    mapId: "map-groudon",
    neutralId: "sitrus",
    left: "36.72%",
    top: "64.44%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-groudon",
    neutralId: "sitrus",
    left: "34.73%",
    top: "68.53%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-groudon",
    neutralId: "sitrus",
    left: "63%",
    top: "66.5%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-groudon",
    neutralId: "sitrus",
    left: "64%",
    top: "72%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-groudon",
    neutralId: "sitrus",
    left: "38.5%",
    top: "22.5%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-groudon",
    neutralId: "sitrus",
    left: "37.5%",
    top: "18%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-groudon",
    neutralId: "sitrus",
    left: "62%",
    top: "22%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-groudon",
    neutralId: "sitrus",
    left: "63%",
    top: "17.5%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-groudon",
    neutralId: "salac",
    left: "46%",
    top: "51%",
    spawnTime: "08:30",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "salac",
  },
  {
    mapId: "map-groudon",
    neutralId: "salac",
    left: "55%",
    top: "51%",
    spawnTime: "08:30",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "salac",
  },
  {
    mapId: "map-groudon",
    neutralId: "salac",
    left: "46%",
    top: "36%",
    spawnTime: "08:30",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "salac",
  },
  {
    mapId: "map-groudon",
    neutralId: "salac",
    left: "54.5%",
    top: "36%",
    spawnTime: "08:30",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "salac",
  },
  {
    mapId: "map-groudon",
    neutralId: "altaria",
    left: "0%",
    top: "0%",
    spawnTime: "NaN:NaN",
    respawnTime: 0,
    permanentDelete: false,
    despawnTime: "02:00",
    infoKey: "altaria.after_regidrago",
  },
  // --- map-kyogre ---
  {
    mapId: "map-kyogre",
    neutralId: "kyogre",
    left: "50%",
    top: "42.5%",
    spawnTime: "02:00",
    respawnTime: 0,
    permanentDelete: false,
    infoKey: "kyogre.boss",
  },
  {
    mapId: "map-kyogre",
    neutralId: "bunnelby",
    left: "20%",
    top: "48.5%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.initial",
  },
  {
    mapId: "map-kyogre",
    neutralId: "bunnelby",
    left: "20%",
    top: "39%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.initial",
  },
  {
    mapId: "map-kyogre",
    neutralId: "bunnelby",
    left: "23.5%",
    top: "58%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.initial",
  },
  {
    mapId: "map-kyogre",
    neutralId: "bunnelby",
    left: "24.5%",
    top: "31%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.initial",
  },
  {
    mapId: "map-kyogre",
    neutralId: "bunnelby",
    left: "32.39%",
    top: "65.44%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.initial",
  },
  {
    mapId: "map-kyogre",
    neutralId: "bunnelby",
    left: "33.5%",
    top: "23.5%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.initial",
  },
  {
    mapId: "map-kyogre",
    neutralId: "bunnelby",
    left: "81%",
    top: "49%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.initial",
  },
  {
    mapId: "map-kyogre",
    neutralId: "bunnelby",
    left: "80%",
    top: "37.5%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.initial",
  },
  {
    mapId: "map-kyogre",
    neutralId: "bunnelby",
    left: "76.5%",
    top: "58.5%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.initial",
  },
  {
    mapId: "map-kyogre",
    neutralId: "bunnelby",
    left: "75.5%",
    top: "30.5%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.initial",
  },
  {
    mapId: "map-kyogre",
    neutralId: "bunnelby",
    left: "67.5%",
    top: "66.5%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.initial",
  },
  {
    mapId: "map-kyogre",
    neutralId: "bunnelby",
    left: "67%",
    top: "22.5%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.initial",
  },
  {
    mapId: "map-kyogre",
    neutralId: "bunnelby",
    left: "50.06%",
    top: "13.96%",
    spawnTime: "09:40",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "bunnelby.lane",
  },
  {
    mapId: "map-kyogre",
    neutralId: "bunnelby",
    left: "56.84%",
    top: "12.79%",
    spawnTime: "09:20",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "bunnelby.lane_920_short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "bunnelby",
    left: "44%",
    top: "14%",
    spawnTime: "09:20",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "bunnelby.lane_920_short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "bunnelby",
    left: "48.89%",
    top: "75.97%",
    spawnTime: "09:40",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "bunnelby.lane",
  },
  {
    mapId: "map-kyogre",
    neutralId: "bunnelby",
    left: "51.7%",
    top: "75.97%",
    spawnTime: "09:40",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "bunnelby.lane",
  },
  {
    mapId: "map-kyogre",
    neutralId: "bunnelby",
    left: "50%",
    top: "62%",
    spawnTime: "09:15",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "bunnelby.lane_915_short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "accelgor",
    left: "29%",
    top: "50.5%",
    spawnTime: "09:45",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "accelgor",
  },
  {
    mapId: "map-kyogre",
    neutralId: "accelgor",
    left: "71.5%",
    top: "50%",
    spawnTime: "09:45",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "accelgor",
  },
  {
    mapId: "map-kyogre",
    neutralId: "escavalier",
    left: "35.5%",
    top: "34.5%",
    spawnTime: "09:45",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "escavalier",
  },
  {
    mapId: "map-kyogre",
    neutralId: "escavalier",
    left: "65%",
    top: "35%",
    spawnTime: "09:45",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "escavalier",
  },
  {
    mapId: "map-kyogre",
    neutralId: "baltoy",
    left: "28.5%",
    top: "38.5%",
    spawnTime: "09:45",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.945_short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "baltoy",
    left: "35%",
    top: "50%",
    spawnTime: "09:45",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.945_short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "baltoy",
    left: "71.5%",
    top: "38%",
    spawnTime: "09:45",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.945_short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "baltoy",
    left: "66%",
    top: "51%",
    spawnTime: "09:45",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.945_short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "baltoy",
    left: "56.84%",
    top: "22.15%",
    spawnTime: "09:40",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_940_short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "baltoy",
    left: "43.5%",
    top: "24%",
    spawnTime: "09:40",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_940_short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "baltoy",
    left: "50.06%",
    top: "10.45%",
    spawnTime: "09:10",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_910_short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "baltoy",
    left: "35%",
    top: "15%",
    spawnTime: "09:10",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_910_short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "baltoy",
    left: "66%",
    top: "15%",
    spawnTime: "09:10",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_910_short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "baltoy",
    left: "33.5%",
    top: "76%",
    spawnTime: "09:10",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_910_short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "baltoy",
    left: "67.5%",
    top: "75.5%",
    spawnTime: "09:10",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_910_short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "baltoy",
    left: "43.5%",
    top: "45.5%",
    spawnTime: "08:40",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_840_short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "baltoy",
    left: "57%",
    top: "45.5%",
    spawnTime: "08:40",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_840_short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "baltoy",
    left: "30%",
    top: "32.5%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.tower_kyogre",
  },
  {
    mapId: "map-kyogre",
    neutralId: "baltoy",
    left: "69.5%",
    top: "32%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.tower_kyogre",
  },
  {
    mapId: "map-kyogre",
    neutralId: "baltoy",
    left: "28%",
    top: "55%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.tower_kyogre",
  },
  {
    mapId: "map-kyogre",
    neutralId: "baltoy",
    left: "72.5%",
    top: "54%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.tower_kyogre",
  },
  {
    mapId: "map-kyogre",
    neutralId: "regidrago",
    left: "50%",
    top: "52%",
    spawnTime: "08:00",
    respawnTime: 120,
    permanentDelete: false,
    despawnTime: "02:00",
    infoKey: "regidrago.kyogre",
  },
  {
    mapId: "map-kyogre",
    neutralId: "regieleki",
    left: "50%",
    top: "10%",
    spawnTime: "07:00",
    respawnTime: 120,
    permanentDelete: false,
    despawnTime: "02:00",
    infoKey: "regi.700",
  },
  {
    mapId: "map-kyogre",
    neutralId: "regieleki",
    left: "50%",
    top: "85.5%",
    spawnTime: "07:00",
    respawnTime: 120,
    permanentDelete: false,
    despawnTime: "02:00",
    infoKey: "regi.700",
  },
  {
    mapId: "map-kyogre",
    neutralId: "regice",
    left: "50%",
    top: "3.5%",
    spawnTime: "07:00",
    respawnTime: 120,
    permanentDelete: false,
    despawnTime: "02:00",
    infoKey: "regi.700",
  },
  {
    mapId: "map-kyogre",
    neutralId: "regice",
    left: "50.06%",
    top: "92.35%",
    spawnTime: "07:00",
    respawnTime: 120,
    permanentDelete: false,
    despawnTime: "02:00",
    infoKey: "regi.700",
  },
  {
    mapId: "map-kyogre",
    neutralId: "registeel",
    left: "46.5%",
    top: "7%",
    spawnTime: "07:00",
    respawnTime: 120,
    permanentDelete: false,
    despawnTime: "02:00",
    infoKey: "regi.700",
  },
  {
    mapId: "map-kyogre",
    neutralId: "registeel",
    left: "46%",
    top: "90%",
    spawnTime: "07:00",
    respawnTime: 120,
    permanentDelete: false,
    despawnTime: "02:00",
    infoKey: "regi.700",
  },
  {
    mapId: "map-kyogre",
    neutralId: "regirock",
    left: "54%",
    top: "7.5%",
    spawnTime: "07:00",
    respawnTime: 120,
    permanentDelete: false,
    despawnTime: "02:00",
    infoKey: "regi.700",
  },
  {
    mapId: "map-kyogre",
    neutralId: "regirock",
    left: "53.5%",
    top: "90%",
    spawnTime: "07:00",
    respawnTime: 120,
    permanentDelete: false,
    despawnTime: "02:00",
    infoKey: "regi.700",
  },
  {
    mapId: "map-kyogre",
    neutralId: "xatu",
    left: "23.62%",
    top: "42.04%",
    spawnTime: "09:59",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "xatu.short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "xatu",
    left: "75.5%",
    top: "43%",
    spawnTime: "09:59",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "xatu.short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "natu",
    left: "49%",
    top: "43%",
    spawnTime: "09:00",
    respawnTime: 0,
    permanentDelete: true,
    despawnTime: "02:00",
    infoKey: "natu.900",
  },
  {
    mapId: "map-kyogre",
    neutralId: "natu",
    left: "51%",
    top: "43%",
    spawnTime: "09:20",
    respawnTime: 60,
    permanentDelete: false,
    despawnTime: "02:00",
    infoKey: "natu.920",
  },
  {
    mapId: "map-kyogre",
    neutralId: "indeedee",
    left: "42.5%",
    top: "77.5%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.lane_930",
  },
  {
    mapId: "map-kyogre",
    neutralId: "indeedee",
    left: "44%",
    top: "64.5%",
    spawnTime: "09:35",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.lane_935",
  },
  {
    mapId: "map-kyogre",
    neutralId: "indeedee",
    left: "57%",
    top: "76.5%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.lane_930",
  },
  {
    mapId: "map-kyogre",
    neutralId: "indeedee",
    left: "56%",
    top: "63.5%",
    spawnTime: "09:35",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.lane_935",
  },
  {
    mapId: "map-kyogre",
    neutralId: "indeedee",
    left: "29%",
    top: "18.5%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.tower_short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "indeedee",
    left: "22%",
    top: "25%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.tower_short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "indeedee",
    left: "18.5%",
    top: "31.5%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.tower_short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "indeedee",
    left: "71.5%",
    top: "18%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.tower_short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "indeedee",
    left: "78%",
    top: "24.5%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.tower_short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "indeedee",
    left: "81.5%",
    top: "32%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.tower_short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "indeedee",
    left: "16.5%",
    top: "59%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.tower_short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "indeedee",
    left: "20%",
    top: "64%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.tower_short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "indeedee",
    left: "81%",
    top: "63.5%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.tower_short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "indeedee",
    left: "84%",
    top: "58.5%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.tower_short",
  },
  {
    mapId: "map-kyogre",
    neutralId: "sitrus",
    left: "38%",
    top: "66.5%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-kyogre",
    neutralId: "sitrus",
    left: "37%",
    top: "71%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-kyogre",
    neutralId: "sitrus",
    left: "63%",
    top: "66.5%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-kyogre",
    neutralId: "sitrus",
    left: "63.5%",
    top: "71.5%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-kyogre",
    neutralId: "sitrus",
    left: "38.5%",
    top: "22.5%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-kyogre",
    neutralId: "sitrus",
    left: "37.5%",
    top: "18%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-kyogre",
    neutralId: "sitrus",
    left: "62%",
    top: "22.5%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-kyogre",
    neutralId: "sitrus",
    left: "62.5%",
    top: "18.5%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-kyogre",
    neutralId: "sitrus",
    left: "46%",
    top: "51.5%",
    spawnTime: "08:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-kyogre",
    neutralId: "sitrus",
    left: "54.5%",
    top: "50.81%",
    spawnTime: "08:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-kyogre",
    neutralId: "sitrus",
    left: "46%",
    top: "36%",
    spawnTime: "08:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-kyogre",
    neutralId: "sitrus",
    left: "54%",
    top: "35.5%",
    spawnTime: "08:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-kyogre",
    neutralId: "sitrus",
    left: "36.72%",
    top: "42.04%",
    spawnTime: "05:00",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-kyogre",
    neutralId: "sitrus",
    left: "63.4%",
    top: "42.04%",
    spawnTime: "05:00",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-kyogre",
    neutralId: "altaria",
    left: "0%",
    top: "0%",
    spawnTime: "NaN:NaN",
    respawnTime: 0,
    permanentDelete: false,
    despawnTime: "02:00",
    infoKey: "altaria.after_regidrago",
  },
  // --- map-rayquaza ---
  {
    mapId: "map-rayquaza",
    neutralId: "rayquaza",
    left: "50%",
    top: "43%",
    spawnTime: "02:00",
    respawnTime: 0,
    permanentDelete: false,
    infoKey: "rayquaza.boss",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "bunnelby",
    left: "20%",
    top: "48.5%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.points",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "bunnelby",
    left: "20%",
    top: "38.5%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.points",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "bunnelby",
    left: "24%",
    top: "58%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.points",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "bunnelby",
    left: "25.5%",
    top: "30.5%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.points",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "bunnelby",
    left: "34%",
    top: "65.5%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.points",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "bunnelby",
    left: "33%",
    top: "69%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.points",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "bunnelby",
    left: "34%",
    top: "24.5%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.points",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "bunnelby",
    left: "33.5%",
    top: "21.5%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.points",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "bunnelby",
    left: "81%",
    top: "48%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.points",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "bunnelby",
    left: "80.5%",
    top: "38.5%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.points",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "bunnelby",
    left: "76.77%",
    top: "58.42%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.points",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "bunnelby",
    left: "75.5%",
    top: "31%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.points",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "bunnelby",
    left: "67%",
    top: "65%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.points",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "bunnelby",
    left: "68%",
    top: "68.5%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.points",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "bunnelby",
    left: "66%",
    top: "20.5%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.points",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "bunnelby",
    left: "65%",
    top: "23%",
    spawnTime: "10:00",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "bunnelby.points",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "bunnelby",
    left: "50%",
    top: "14.5%",
    spawnTime: "09:40",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "bunnelby.lane",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "bunnelby",
    left: "56.65%",
    top: "12.79%",
    spawnTime: "09:20",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "bunnelby.lane_920_short",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "bunnelby",
    left: "42.61%",
    top: "12.79%",
    spawnTime: "09:20",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "bunnelby.lane_920_short",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "bunnelby",
    left: "48.69%",
    top: "75.97%",
    spawnTime: "09:40",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "bunnelby.lane",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "bunnelby",
    left: "51.5%",
    top: "75.97%",
    spawnTime: "09:40",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "bunnelby.lane",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "bunnelby",
    left: "49.86%",
    top: "60.17%",
    spawnTime: "09:15",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "bunnelby.lane_915_short",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "accelgor",
    left: "35.5%",
    top: "52%",
    spawnTime: "09:45",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "accelgor",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "accelgor",
    left: "64.5%",
    top: "51.5%",
    spawnTime: "09:45",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "accelgor",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "escavalier",
    left: "36%",
    top: "34%",
    spawnTime: "09:45",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.945_short",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "escavalier",
    left: "65.5%",
    top: "35.5%",
    spawnTime: "09:45",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.945_short",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "baltoy",
    left: "29%",
    top: "38.5%",
    spawnTime: "09:45",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.945_short",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "baltoy",
    left: "28%",
    top: "49.5%",
    spawnTime: "09:45",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.945_short",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "baltoy",
    left: "73.26%",
    top: "36.19%",
    spawnTime: "09:45",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.945_short",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "baltoy",
    left: "72.5%",
    top: "50%",
    spawnTime: "09:45",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.945_short",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "baltoy",
    left: "49.98%",
    top: "23.9%",
    spawnTime: "09:40",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_940_short",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "baltoy",
    left: "56.65%",
    top: "22.15%",
    spawnTime: "09:40",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_940_short",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "baltoy",
    left: "42.61%",
    top: "22.15%",
    spawnTime: "09:40",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_940_short",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "baltoy",
    left: "50%",
    top: "10.5%",
    spawnTime: "09:10",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_910_short",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "baltoy",
    left: "33.13%",
    top: "12.79%",
    spawnTime: "09:10",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_910_short",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "baltoy",
    left: "65.5%",
    top: "14.5%",
    spawnTime: "09:10",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_910_short",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "baltoy",
    left: "33%",
    top: "75.5%",
    spawnTime: "09:10",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_910_short",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "baltoy",
    left: "67.5%",
    top: "76.5%",
    spawnTime: "09:10",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_910_short",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "baltoy",
    left: "43%",
    top: "43.5%",
    spawnTime: "08:40",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_840_short",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "baltoy",
    left: "57%",
    top: "43%",
    spawnTime: "08:40",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.lane_840_short",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "baltoy",
    left: "29.5%",
    top: "32%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.tower_break",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "baltoy",
    left: "71.86%",
    top: "29.75%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.tower_break",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "baltoy",
    left: "28%",
    top: "54.5%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.tower_break",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "baltoy",
    left: "73%",
    top: "55%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.tower_break",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "regieleki",
    left: "49.86%",
    top: "8.11%",
    spawnTime: "07:00",
    respawnTime: 120,
    permanentDelete: false,
    despawnTime: "02:00",
    infoKey: "regi.700",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "regice",
    left: "49.86%",
    top: "85.33%",
    spawnTime: "07:00",
    respawnTime: 120,
    permanentDelete: false,
    despawnTime: "02:00",
    infoKey: "regi.700",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "registeel",
    left: "45.18%",
    top: "85.33%",
    spawnTime: "07:00",
    respawnTime: 120,
    permanentDelete: false,
    despawnTime: "02:00",
    infoKey: "regi.700",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "regirock",
    left: "54.54%",
    top: "85.33%",
    spawnTime: "07:00",
    respawnTime: 120,
    permanentDelete: false,
    despawnTime: "02:00",
    infoKey: "regi.700",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "xatu",
    left: "25.5%",
    top: "43%",
    spawnTime: "09:59",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "xatu.short",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "xatu",
    left: "74.5%",
    top: "43.5%",
    spawnTime: "09:59",
    respawnTime: 0,
    permanentDelete: true,
    infoKey: "xatu.short",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "indeedee",
    left: "42.5%",
    top: "77.5%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.lane_930",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "indeedee",
    left: "43.5%",
    top: "64%",
    spawnTime: "09:35",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.lane_935",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "indeedee",
    left: "58%",
    top: "77%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.lane_930",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "indeedee",
    left: "57%",
    top: "64%",
    spawnTime: "09:35",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "indeedee.lane_935",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "indeedee",
    left: "28.5%",
    top: "18%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.tower_break",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "indeedee",
    left: "22.5%",
    top: "25%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.tower_break",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "indeedee",
    left: "19%",
    top: "31.5%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.tower_break",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "indeedee",
    left: "71.5%",
    top: "18%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.tower_break",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "indeedee",
    left: "78.5%",
    top: "24.5%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.tower_break",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "indeedee",
    left: "82%",
    top: "32%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.tower_break",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "indeedee",
    left: "16.5%",
    top: "59.5%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.tower_break",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "indeedee",
    left: "19.5%",
    top: "64.5%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.tower_break",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "indeedee",
    left: "81%",
    top: "64.5%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.tower_break",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "indeedee",
    left: "84%",
    top: "59.5%",
    spawnTime: "10:00",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "baltoy.tower_break",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "sitrus",
    left: "37.5%",
    top: "67.5%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-rayquaza",
    neutralId: "sitrus",
    left: "36.5%",
    top: "71%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-rayquaza",
    neutralId: "sitrus",
    left: "63%",
    top: "67%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-rayquaza",
    neutralId: "sitrus",
    left: "64%",
    top: "72%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-rayquaza",
    neutralId: "sitrus",
    left: "38.5%",
    top: "22.5%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-rayquaza",
    neutralId: "sitrus",
    left: "38%",
    top: "18%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-rayquaza",
    neutralId: "sitrus",
    left: "61.5%",
    top: "22.5%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-rayquaza",
    neutralId: "sitrus",
    left: "62.5%",
    top: "18.5%",
    spawnTime: "09:30",
    respawnTime: 60,
    permanentDelete: false,
  },
  {
    mapId: "map-rayquaza",
    neutralId: "salac",
    left: "45.5%",
    top: "51%",
    spawnTime: "08:30",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "salac.short",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "salac",
    left: "55%",
    top: "50.5%",
    spawnTime: "08:30",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "salac.short",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "salac",
    left: "46%",
    top: "36%",
    spawnTime: "08:30",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "salac.short",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "salac",
    left: "54.5%",
    top: "36.5%",
    spawnTime: "08:30",
    respawnTime: 60,
    permanentDelete: false,
    infoKey: "salac.short",
  },
  {
    mapId: "map-rayquaza",
    neutralId: "altaria",
    left: "50%",
    top: "43%",
    spawnTime: "08:00",
    respawnTime: 90,
    permanentDelete: false,
    despawnTime: "02:00",
    infoKey: "altaria.rayquaza",
  }
];

export default spawns;
